import Animation from './animation'

class BasicAnimation extends Animation {

  match () {
    return true
  }

}

export default BasicAnimation
